import React from 'react';
import css from './CreationRender.module.scss';
import moment from 'moment';
import renderHTML from 'react-render-html';
import {stateToHTML} from 'draft-js-export-html';
import {convertFromRaw} from 'draft-js';

const CreationRender = (props) => {

  const getPhoto = () => {
    if (!props.previewModel) {
      return props.defaultImage;
    }

    if (props.previewModel.cover_photo === undefined && props.previewModel.has_image) {
      return props.previewModel.image_link;
    }

    return props.previewModel.cover_photo || props.defaultImage;
  };

  return (<div className={`${css.render} ${props.customClass}`}>
    <div className={css.render__content}>

      <img src="/static/images/logos/logo.svg"/>

      <h2>
        {(props.previewModel && props.previewModel.name) && (<React.Fragment>
          {props.previewModel.name}
        </React.Fragment>)}

        {!(props.previewModel && props.previewModel.name) && (<React.Fragment>
          <span/><span/>
        </React.Fragment>)}
      </h2>
      <h3>
        {(props.previewModel && (props.previewModel.organizer_name
          || props.previewModel.event_date)) && (<React.Fragment>{props.previewModel.event_date
        && moment(props.previewModel.event_date).locale("fr").format("DD MMMM YYYY")} {(props.previewModel.event_date
          && props.previewModel.organizer_name) && '-'} {props.previewModel.organizer_name
        && `Organisé par ${props.previewModel.organizer_name}`}</React.Fragment>)}

        {!(props.previewModel && (props.previewModel.organizer_name
          || props.previewModel.event_date)) && (<React.Fragment>
          <span/>
        </React.Fragment>)}

      </h3>

      <div className={css.desc}>
        {(props.previewModel && props.previewModel.description) && (<div className={css.description}>
          {renderHTML(stateToHTML(convertFromRaw(props.previewModel.description)))}
        </div>)}

        {!(props.previewModel && props.previewModel.description) && (<React.Fragment>
          <span/><span/><span/>
        </React.Fragment>)}

      </div>
    </div>

    <div className={css.render__img} style={{backgroundImage: `url(${getPhoto()})`}}/>
  </div>);
};

export default CreationRender;
